import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Admin/App';
import TeacherApp from './Teacher/TeacherApp'
import * as serviceWorker from './serviceWorker';

import { createStore } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './store/rootReducer';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

// import StudentApp from './Student/StudentApp'
// import Parent from './Student/content/Parent/Parent';
import ParentApp from './Parent/ParentApp'
// import Div from './hoc/Div'
import Login from './login'
const store = createStore(rootReducer)

ReactDOM.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    {/* <App /> */}
    {/* <StudentApp/> */}
    {/* <ParentApp /> */}
    {/* <TeacherApp /> */}
    <Login />
    {/* </React.StrictMode> */}
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
